import React from "react"
import Img from "gatsby-image"
import Link from 'gatsby-link'
import ComoComprar from '../components/modal'
import MoneyIcon from 'react-icons/lib/md/attach-money'
import HomeIcon from 'react-icons/lib/md/home'


const RecipeTemplate = ({ data }) => (
  <div className="pieza-layout">

      <figure className="image">        
        <Img
          sizes={
            data.recipes.relationships.image.relationships.imageFile.localFile
              .childImageSharp.sizes
          }
        />   
      </figure>
  
      <section>
        <h2>{data.recipes.title}</h2>        
        <h5 className="precio">Precio: $ {data.recipes.numberOfServices}</h5>        
        <Link to="/"><HomeIcon /> Volver al Inicio</Link>
        <hr />
        <ComoComprar vendido={data.recipes.vendido}/>
        <div className="content" dangerouslySetInnerHTML={{__html: data.recipes.instructions}} />
        <hr />      
        <h4>Características</h4>
        <ul className="features">
          {data.recipes.ingredients &&
            data.recipes.ingredients.map(item => <li>{item}</li>)}
        </ul>
      </section>

  </div>
)

export default RecipeTemplate

export const query = graphql`
  query RecipeTemplate($slug: String!) {
    recipes(fields: { slug: { eq: $slug } }) {
      title
      ingredients
      numberOfServices
      instructions
      vendido
      relationships {
        image {
          relationships {
            imageFile {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 960) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/recipe.js